/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Boarding pass send status
 */
export enum CheckInBoardingPassByEmailResponseStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE'
}

